import { NotifyHelper } from "../../../helpers/toast";
import { ePhongUuTienNhomActionsObj } from "../../action-types/category/IPhongUuTienNhomActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const phongUuTienNhomActions = {
    ...generateActions(ePhongUuTienNhomActionsObj, "PHONG_UU_TIEN_NHOM"),
    ...generateActionForKey(ePhongUuTienNhomActionsObj, "PHONG_UU_TIEN_NHOM", "SAVE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(ePhongUuTienNhomActionsObj, "PHONG_UU_TIEN_NHOM", "DELETE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(ePhongUuTienNhomActionsObj, "PHONG_UU_TIEN_NHOM", "SAVE_ERRR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(ePhongUuTienNhomActionsObj, "PHONG_UU_TIEN_NHOM", "DELETE_ERRR", (m) => { NotifyHelper.Error(m) }),
};
